export default __webpack_public_path__ + "static/media/placeholder_dummy2016-kosmetik-mobile-de.c2a8a0d5.png";